import { RouteConfig } from 'vue-router'

import homeworkMenuIcon from '@/assets/images/icon_menu_evaluation@2x.png'
import homeworkMenuIconActive from '@/assets/images/icon_menu_evaluation_active@2x.png'

const Layout = () => import('../views/Layout.vue')
const ClazzResultDetails = () => import('../views/ProcessEvaluationClazzResultDetails.vue')
const StudentResultDetails = () => import('../views/ProcessEvaluationStudentResultDetails.vue')
const CategoryItem = () => import('../views/ProcessEvaluationCategoryItem.vue')
const CategoryItemRecord = () => import('../views/ProcessEvaluationCategoryItemRecord.vue')
const Config = () => import('../views/ProcessEvaluationConfig.vue')

export const ClazzResultDetailsRoute: RouteConfig = {
  path: 'clazz-result-details',
  name: 'evaluation_clazz_result_details',
  component: ClazzResultDetails,
  meta: {
    title: '成绩明细',
    showMenu: false,
  },
}

export const StudentResultDetailsRoute: RouteConfig = {
  path: 'student-result-details',
  name: 'evaluation_student_result_details',
  component: StudentResultDetails,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '成绩明细',
    showMenu: false,
  },
}

export const CategoryItemRecordRoute: RouteConfig = {
  path: 'category-item-record',
  name: 'evaluation_record',
  component: CategoryItemRecord,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '成绩记录',
    showMenu: false,
  },
}

export const CategoryItemRoute: RouteConfig = {
  path: 'category-items',
  name: 'evaluation_category_items',
  component: CategoryItem,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '指标成绩明细',
    showMenu: false,
  },
}

export const ConfigRoute: RouteConfig = {
  path: 'config',
  name: 'evaluation_config',
  component: Config,
  meta: {
    title: '方案配置',
    showMenu: false,
  },
}

export default [
  {
    path: '/process-evaluation',
    name: 'process_evaluation',
    component: Layout,
    meta: {
      title: '过程性评价',
      icon: homeworkMenuIcon,
      iconActive: homeworkMenuIconActive,
      showMenu: false,
    },
    children: [
      ClazzResultDetailsRoute,
      StudentResultDetailsRoute,
      CategoryItemRoute,
      CategoryItemRecordRoute,
      ConfigRoute,
    ],
  },
]
